import React, { useCallback, useMemo } from 'react';
import clsx from 'clsx';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

import './CommonCheckbox.scss';

const CommonCheckbox = ({ checked, onChange, disabled, size = 'sm', readonly, ...rest }) => {
  const handleChange = useCallback(() => {
    if (!disabled && !readonly) {
      onChange(!checked);
    }
  }, [checked, onChange, disabled, readonly]);

  const sizesMap = useMemo(
    () => ({
      sm: `common-checkbox_wrapper--size-sm`,
      md: `common-checkbox_wrapper--size-md`,
      bg: `common-checkbox_wrapper--size-bg`,
    }),
    [],
  );

  return (
    <div className='common-checkbox' role='presentation'>
      <input type='checkbox' checked={checked} onChange={handleChange} {...rest} className='common-checkbox_input' />
      <div className={clsx('common-checkbox_wrapper', sizesMap[size])}>
        <Icon icon={ICONS.Tick} className='common-checkbox_icon' disableCommonStyles disableCommonColors />
      </div>
    </div>
  );
};

export default CommonCheckbox;
